import { history } from '../store';
export var routerMiddleware = function () { return function (next) { return function (action) {
    if (action.type === 'ROUTE' && action.to) {
        history.push(action.to);
    }
    next(action);
}; }; };
